import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetImagePath } from 'interfaces/constants'

export const StyledEmbedCarousel = styled.div`
  margin: 24px 0 48px 0;
  background-size: cover;
  ${MediaQueries.mbDown} {
    background-image: url('${assetImagePath}/bg-m.png}');
    width: 100vw;
    margin-left: -1rem;
    .bullet-nav {
      bottom: 24px;
    }
  }
  ${MediaQueries.mbUp} {
    background-image: url('${assetImagePath}/bg-d.png}');
    .arrow-right {
      right: -16px;
      cursor: pointer;
      svg {
        fill: white;
      }
    }
    .arrow-left {
      left: -16px;
      cursor: pointer;
      svg {
        fill: white;
      }
    }
  }
`
export const StyledCardItem = styled.div`
  width: 100%;
  margin: 0 0 8px 0;
  border-radius: ${theme.borderRadius};
  ${MediaQueries.mbDown} {
    min-height: 318px;
    padding: 24px 16px 48px 16px;
  }
  ${MediaQueries.mbUp} {
    max-width: 768px;
  }
  .post-divider {
    border-top: 0.5px solid #e4e8ec;
    border-bottom: none;
    margin: 0;
  }
`
export const StyledPostContent = styled.div`
  ${MediaQueries.mbDown} {
    min-height: 262px;
  }
  ${MediaQueries.mbUp} {
    padding: 78px 0 81px 0;
    min-height: 332px;
  }
  .post-title {
    margin-top: 16px;
    -webkit-box-orient: horizontal;
    -webkit-line-clamp: 2;
    .img {
      width: auto;
    }
  }
  .second {
    margin-top: 124px;
  }
`
export const StyledLeftInfo = styled.div`
  display: flex;
  align-items: start;
  ${MediaQueries.mbUp} {
    max-width: 546px;
    margin-left: auto;
    margin-right: auto;
    .img-title {
      height: 140px;
      width: auto;
      margin-right: 16px;
    }
    .mid-content {
      display: flex;
    }
    .banner-title {
      font-size: 32px;
      letter-spacing: -1px;
      line-height: 42px;
    }
  }
  ${MediaQueries.mbDown} {
    display: block;
    .img-mb {
      height: 100px;
      width: auto;
    }
    .post-space {
      margin-top: 160px;
    }
    .banner-title {
      padding: 0 24px;
      font-size: 24px;
      line-height: 32px;
      text-align: center;
    }
    .banner-description {
      text-align: center;
    }
  }
  .banner-title {
    color: ${theme.colors.secondaryBase};
  }
  .banner-description {
    margin-top: 8px;
    color: ${theme.colors.secondaryBase};
    font-size: 16px;
    line-height: 24px;
  }
`

export const StyledMidInfo = styled.div`
  display: flex;
  max-width: 546px;
  justify-content: space-between;
  ${MediaQueries.mbUp} {
    padding: 0 28px;
  }
  &[data-has-legend='true'] {
    margin-top: 42px;
  }
  &[data-has-legend='false'] {
    margin-top: 137px;
  }
  margin-right: auto;
  margin-bottom: 57px;
  margin-left: auto;
  .img-container {
    max-width: 180px;
    align-items: center;
    .img-caption {
      margin-top: 16px;
      color: ${theme.colors.secondaryDark};
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      letter-spacing: -0.6px;
      line-height: 32px;
      text-align: center;
    }
  }
  .img-container img {
    width: unset;
  }
  .columns {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    img {
      height: auto;
      ${MediaQueries.mbUp} {
        width: 180px;
      }
      ${MediaQueries.mbDown} {
        width: 100px;
      }
    }
  }
`
export const StyledBottomInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .legend-content {
    color: #284a75;
    font-size: 14px;
    line-height: 22px;
  }
  .flag {
    img {
      width: 28px;
      height: 28px;
    }
    margin-right: 12px;
  }
  .info {
    padding-bottom: 20px;
  }
  .end-post {
    padding-bottom: 81px;
  }
`

export const StyledLegendContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  ${MediaQueries.mbUp} {
    max-width: 577px;
  }
  ${MediaQueries.mbDown} {
    padding: 0 8px;
  }
`
export const StyledStatisticCardItem = styled.div`
  ${MediaQueries.mbDown} {
    width: 375px;
    max-height: 600px;
  }
  img {
    width: 100%;
    height: auto;
  }
`
